import {createApp} from 'vue'
import ElementPlus from 'element-plus'
import 'normalize.css/normalize.css'
import 'element-plus/dist/index.css'
import App from './App.vue'
import * as ElIconModules from '@element-plus/icons-vue'
import 'font-awesome/css/font-awesome.css'
import 'animate.css';
import VueParticles from 'vue-particles'
import CKEditor from '@ckeditor/ckeditor5-vue';
import JoysunFrame from 'joysun-frame'
import 'joysun-frame/dist/style.css'
import contextmenu from "v-contextmenu";
//import BaiduMap from 'vue-baidu-map';
import "v-contextmenu/dist/themes/default.css";
import './style.less';
import './icon.less';
import sysMethod from './method/sys'
import vue3TreeOrg from 'vue3-tree-org';
import "vue3-tree-org/lib/vue3-tree-org.css";

import common from "./commFunction/common";

let app = createApp(App);
app.config.globalProperties.$sysMethod= sysMethod
app.config.globalProperties.$common= common

app.use(ElementPlus)
    .use(VueParticles)
    .use(CKEditor)
    //.use(BaiduMap, {ak: 'qN6f8luOgorhLZWG2oZUd0XFtGPKwhXH'})// 这样引用不成功，放到public/index.html里面了
    .use(contextmenu)
    .use(JoysunFrame)
    .use(vue3TreeOrg)

Object.keys(ElIconModules).forEach(iconName => {
    let alias = 'ElIcon' + iconName;
    app.component(alias, ElIconModules[iconName])
})


app.mount('#app')
